import script from "./MyKpisSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MyKpisSection.vue?vue&type=script&setup=true&lang=js"

import "./MyKpisSection.vue?vue&type=style&index=0&id=6dba86f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dba86f4"]])

export default __exports__